import { useEffect, useState } from "react";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { WifiOff, Wifi } from "lucide-react";

export function OfflineIndicator() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [wasOffline, setWasOffline] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      if (wasOffline) {
        // Show "back online" message briefly
        setTimeout(() => setWasOffline(false), 3000);
      }
    };

    const handleOffline = () => {
      setIsOnline(false);
      setWasOffline(true);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [wasOffline]);

  if (isOnline && !wasOffline) return null;

  return (
    <div className="fixed top-16 left-1/2 -translate-x-1/2 z-50 animate-fade-in" role="status" aria-live="polite" aria-atomic="true">
      <Alert 
        className={`shadow-lg ${
          isOnline 
            ? 'bg-success/10 border-success text-success-foreground' 
            : 'bg-warning/10 border-warning text-warning-foreground'
        }`}
        aria-label={isOnline ? "Connection status: Online" : "Connection status: Offline"}
      >
        <div className="flex items-center gap-2">
          {isOnline ? (
            <>
              <Wifi className="h-4 w-4" aria-hidden="true" />
              <AlertDescription>Back online! All changes will sync.</AlertDescription>
            </>
          ) : (
            <>
              <WifiOff className="h-4 w-4" aria-hidden="true" />
              <AlertDescription>You're offline. Changes will sync when reconnected.</AlertDescription>
            </>
          )}
        </div>
      </Alert>
    </div>
  );
}
